export default __webpack_public_path__ + "static/media/msplogo.dbc21849.png";